import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetSupplierStatementsApi } from './use-get-supplier-statements-api';

const endpoint = 'ums/v1/cms/bnpl/supplier-statements';

type TData = Record<string, any>;
type TError = AxiosError;
type TVariables = { body: FormData };
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useCreateSupplierStatementApi(options?: Options): ReturnType {
  const { refetch: refetchStatements } = useGetSupplierStatementsApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ body }: TVariables) => {
    try {
      const { data } = await http.post(endpoint, body, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [endpoint],
    onSuccess: () => {
      refetchStatements();
      toast({ description: 'Supplier statement uploaded successfully', status: 'success' });
    },
  });
}
